import {
    TIMBERLAND_REDIRECT_URL_DE_AT,
    TIMBERLAND_REDIRECT_URL_DE_BE,
    TIMBERLAND_REDIRECT_URL_DE_CH,
    TIMBERLAND_REDIRECT_URL_DE_DE,
    TIMBERLAND_REDIRECT_URL_EN_CH,
    TIMBERLAND_REDIRECT_URL_EN_DK,
    TIMBERLAND_REDIRECT_URL_EN_FI,
    TIMBERLAND_REDIRECT_URL_EN_GB,
    TIMBERLAND_REDIRECT_URL_EN_IE,
    TIMBERLAND_REDIRECT_URL_EN_IS,
    TIMBERLAND_REDIRECT_URL_EN_SE,
    TIMBERLAND_REDIRECT_URL_ES_ES,
    TIMBERLAND_REDIRECT_URL_FR_BE,
    TIMBERLAND_REDIRECT_URL_FR_CH,
    TIMBERLAND_REDIRECT_URL_FR_FR,
    TIMBERLAND_REDIRECT_URL_IT_CH,
    TIMBERLAND_REDIRECT_URL_IT_IT,
    TIMBERLAND_REDIRECT_URL_NL_BE,
    TIMBERLAND_REDIRECT_URL_NL_NL,
} from '../constants';
import { getQueryParamsByName } from './utils/browser';

export const getRedirectUrl = () => {
    const country = getQueryParamsByName('country') || '';
    const locale = getQueryParamsByName('locale') || '';
    let url = TIMBERLAND_REDIRECT_URL_EN_GB;

    switch (`${locale}-${country}`) {
        case 'en-US-GB':
            url = TIMBERLAND_REDIRECT_URL_EN_GB;
            break;
        case 'en-US-IE':
            url = TIMBERLAND_REDIRECT_URL_EN_IE;
            break;
        case 'en-US-CH':
            url = TIMBERLAND_REDIRECT_URL_EN_CH;
            break;
        case 'en-US-DK':
            url = TIMBERLAND_REDIRECT_URL_EN_DK;
            break;
        case 'en-US-SE':
            url = TIMBERLAND_REDIRECT_URL_EN_SE;
            break;
        case 'en-US-FI':
            url = TIMBERLAND_REDIRECT_URL_EN_FI;
            break;
        case 'en-US-IS':
            url = TIMBERLAND_REDIRECT_URL_EN_IS;
            break;

        case 'en-GB-GB':
            url = TIMBERLAND_REDIRECT_URL_EN_GB;
            break;
        case 'en-GB-IE':
            url = TIMBERLAND_REDIRECT_URL_EN_IE;
            break;
        case 'en-GB-CH':
            url = TIMBERLAND_REDIRECT_URL_EN_CH;
            break;
        case 'en-GB-DK':
            url = TIMBERLAND_REDIRECT_URL_EN_DK;
            break;
        case 'en-GB-SE':
            url = TIMBERLAND_REDIRECT_URL_EN_SE;
            break;
        case 'en-GB-FI':
            url = TIMBERLAND_REDIRECT_URL_EN_FI;
            break;
        case 'en-GB-IS':
            url = TIMBERLAND_REDIRECT_URL_EN_IS;
            break;

        case 'de-DE':
            url = TIMBERLAND_REDIRECT_URL_DE_DE;
            break;
        case 'de-AT':
            url = TIMBERLAND_REDIRECT_URL_DE_AT;
            break;
        case 'de-CH':
            url = TIMBERLAND_REDIRECT_URL_DE_CH;
            break;
        case 'de-BE':
            url = TIMBERLAND_REDIRECT_URL_DE_BE;
            break;

        case 'es-ES':
            url = TIMBERLAND_REDIRECT_URL_ES_ES;
            break;

        case 'fr-FR':
            url = TIMBERLAND_REDIRECT_URL_FR_FR;
            break;
        case 'fr-CH':
            url = TIMBERLAND_REDIRECT_URL_FR_CH;
            break;
        case 'fr-BE':
            url = TIMBERLAND_REDIRECT_URL_FR_BE;
            break;

        case 'it-IT':
            url = TIMBERLAND_REDIRECT_URL_IT_IT;
            break;
        case 'it-CH':
            url = TIMBERLAND_REDIRECT_URL_IT_CH;
            break;

        case 'nl-NL':
            url = TIMBERLAND_REDIRECT_URL_NL_NL;
            break;
        case 'nl-BE':
            url = TIMBERLAND_REDIRECT_URL_NL_BE;
            break;

        default:
            url = TIMBERLAND_REDIRECT_URL_EN_GB;
    }
    return url;
};


